import { useDrawer } from '@/components/common/DrawerManager';
import { FlexRow } from '@/components/common/Flex';
import GoalIconCircle from '@/components/goals/GoalIconCircle';
import { FlexProps } from '@chakra-ui/react';
import {
    getName,
    PlentyGoalAccountFinancialEntity,
} from '@common/financialEntities';
import { Goal } from '@common/goals';
import { FC } from 'react';
import { EntityViewHeader } from '../common/EntityView';
import { ChevronRight } from '../common/icons';
import PartnerAvatar from '../common/PartnerAvatar';
import { Subheader } from '../common/Typography';
import { FinancialEntityIcon } from '../financialEntities/FinancialEntityIcon';
import { configByGoalType } from './config';

export interface GoalAccountDetailHeaderProps extends FlexProps {
    goal: Goal;
    goalAccount: PlentyGoalAccountFinancialEntity;
}

const GoalAccountDetailHeader: FC<GoalAccountDetailHeaderProps> = ({
    goal,
    goalAccount,
    ...props
}) => {
    const { showDrawer } = useDrawer();
    const goalConfig = configByGoalType[goal.type];

    return (
        <EntityViewHeader {...props}>
            <FlexRow align="center">
                <GoalIconCircle
                    type="RETIREMENT"
                    mr={2}
                    opacity={0.4}
                    cursor="pointer"
                    onClick={() => {
                        showDrawer({
                            drawerKey: 'goal-detail',
                            entityId: goal.id,
                        });
                    }}
                />
                <ChevronRight size="sm" ml={1} mr={1} />
                <FinancialEntityIcon
                    fe={goalAccount}
                    mr={4}
                    color={goalConfig.color}
                />
                <Subheader>
                    {getName(goalAccount, { withTypeAsName: true })}
                </Subheader>
            </FlexRow>
            {!goalAccount.isMine && <PartnerAvatar />}
        </EntityViewHeader>
    );
};

export default GoalAccountDetailHeader;
